import { u as useSessionStore, e as useProdselStore, b as useConfigStore, a as useAuthStore } from './prodsel.store-B-MQAyQE.mjs';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';

const session = { cart: false};

function getCart() {
    const sessionStore = useSessionStore();
    const { cart } = storeToRefs(sessionStore);
    session.cart = cart; 
}

function getCartItems() {
    const cartValue = session.cart?.value;
    if (Array.isArray(cartValue)) return cartValue
    if (Array.isArray(cartValue?.items)) return cartValue.items
    return []
}

function getPSM() {
    const prodselStore = useProdselStore();
    const { psm } = storeToRefs(prodselStore);
    session.psm = psm;
}

// TODO: dynamic locale
function numberFormat(num, currency) { 
    const fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency });
    if(!isNaN(num)) return fmt.format(num)
    return ""
}

function quantityPrice(product, quantity, config, optionPrices) {

    const prices = product.prices; 
    let price = false;
    let offerPrice = false;
    let standardPrice = false;
    let q0 = false;
    let currency = "EUR";

    if (config) {
        if (config.currency) currency = config.currency;
        if (config.media) config.media;
    }

    const explain = [];

    // Quantity = 0 bringt Fehler es wird der Preis der Einerstaffelpreis ausgegeben
    if (quantity == 0) {
        quantity = 1;
        q0 = true;
    }

    // Check nach welcher Methode die Mengenstaffel berechnet werden soll 
    // QuantityLevelCalculation (qlcalc) 1 = Mengenstaffel pro Datei, 2 = Mengenstaffel pro Produkt
    // calcQuantity ist die Menge aller gleichen Produkte bzw. Dateien im Produktwähler und im Warenkorb

    let calcQuantity = getCumulatedQuantity(product, quantity, config);
    
    if (!calcQuantity) calcQuantity = quantity;

    var curdate = new Date().toISOString();

    let qlOffer = 0;
    let qlStandard = 0;
    let isOffer = false;

    // aufsteigend sortieren, damit höhere Staffeln die niedrigeren korrekt überschreiben
    const sortedPrices = [...prices].sort((a, b) => (Number(a.quantityLevel) || 0) - (Number(b.quantityLevel) || 0));

    // TODO promotionStart NUll value selection
    sortedPrices.forEach(el => {
        const quantityLevel = Number.isFinite(Number(el.quantityLevel)) ? Number(el.quantityLevel) : 0;

        if (el.promotionStart && el.promotionStart <= curdate && el.promotionEnd >= curdate && quantityLevel <= calcQuantity) {
            offerPrice = calcPrice(el, quantity, config);
            offerPrice.quantityLevel = quantityLevel;
        } 
        if ((!el.promotionStart || el.promotionStart[0] == "-") && quantityLevel <= calcQuantity) {
            standardPrice = calcPrice(el, quantity, config);
            standardPrice.quantityLevel = quantityLevel;
        } 

        // Es wird davon ausgegangen, dass alle Elemente in prices diselbe Währung haben
        if (el.waehrung) currency = el.waehrung;
    });

    // current = der günstigste gültige Preis (nicht zwingend der offerPrice, falls eine höhere Staffel ohne offerPrice billiger ist)
    price = standardPrice;
    if (offerPrice && (!standardPrice || offerPrice.amount <= standardPrice.amount)) {
        price = offerPrice;
        isOffer = true;
    }

    explain.push({
            price: price.basePrice || price.amount,
            quantity: quantity,
            calcQuantity: calcQuantity,
            offer: isOffer,
            quantityLevel: price.quantityLevel,
    });
    if (price.additionalPages > 0) {
        explain.push({
            price: price.additionalPages * price.pagePrice * quantity,
            quantity: price.additionalPages * quantity,
            option: "additionalPages",
            offer: isOffer,
            quantityLevel: price.quantityLevel,
        });
    }

    let priceOption = [];
    let offerPriceOption = [];
    let standardPriceOption = [];
    

    if (Array.isArray(optionPrices)) {

        let pid = "";
        optionPrices.forEach((op,i) => {
            if (op.prices) {
                qlOffer = 0;
                qlStandard = 0;
                op.prices.forEach(el => {
                    pid = el.pid;
                    const quantityLevel = Number.isFinite(Number(el.quantityLevel)) ? Number(el.quantityLevel) : 0;
                    // Bei Optionspreisen wird momentan nur die Menge des aktuellen Produktes berücksichtigt. 
                    if (el.promotionStart <= curdate && el.promotionEnd >= curdate && quantityLevel <= quantity) {
                        offerPriceOption[i] = calcOptionPrice(el, quantity, config);
                        qlOffer = quantityLevel;
                    }
                    if ((!el.promotionStart || el.promotionStart[0] == "-") && quantityLevel <= quantity) {
                        standardPriceOption[i] = calcOptionPrice(el, quantity, config);
                        qlStandard = quantityLevel;
                    }

                    if (standardPriceOption[i]) priceOption[i] = standardPriceOption[i];
                    if (offerPriceOption[i]) priceOption[i] = offerPriceOption[i];
                });
            }

            if (offerPriceOption[i]) {
                explain.push({
                    price: offerPriceOption[i],
                    option: pid,
                    name: op.name,
                    quantity: quantity,
                    offer: true,
                    quantityLevel: qlOffer,
                });
            } else if (standardPriceOption[i]) {
                explain.push({
                    price: standardPriceOption[i],
                    option: pid,
                    name: op.name,
                    quantity: quantity,
                    offer: false,
                    quantityLevel: qlStandard,
                });
            } 
        });
    }

    let priceOptionSum = priceOption.reduce((a,c) => a + c, 0);
    let standardPriceOptionSum = standardPriceOption.reduce((a,c) => a + c, 0);
    let offerPriceOptionSum = offerPriceOption.reduce((a,c) => a + c, 0);
    const hasSelectedOffer = isOffer || offerPriceOption.some((optionPrice) => typeof optionPrice !== 'undefined');

    

    if (q0) {
        return {
            current: 0,
            offer: 0,
            standard: 0,
            isOffer: false,
            currentFmt: numberFormat(0, currency),
            offerFmt: numberFormat(0, currency),
            standardFmt: numberFormat(0, currency),
            currentSingleFmt: numberFormat(price.amount / quantity, currency),
            standardSingleFmt: numberFormat(standardPrice.amount / quantity, currency),
            currency: currency,
            explain: explain
        }
    }
    const currentAmount = price.amount + priceOptionSum;
    const standardAmount = standardPrice.amount + standardPriceOptionSum;
    return {
        current: currentAmount,
        offer: offerPrice.amount + offerPriceOptionSum,
        standard: standardAmount,
        isOffer: hasSelectedOffer && Number.isFinite(currentAmount) && Number.isFinite(standardAmount),
        currentFmt: numberFormat(currentAmount, currency),
        offerFmt: numberFormat(offerPrice.amount + offerPriceOptionSum, currency),
        standardFmt: numberFormat(standardAmount, currency),
        currentSingleFmt: numberFormat(currentAmount / quantity, currency),
        standardSingleFmt: numberFormat(standardAmount / quantity, currency),
        currency: currency,
        explain: explain
    }
}

function calcOptionPrice(el, quantity, config) {
    if (config?.pages && el.sPrice) {
        const pages = Number(config.pages) || 0;
        const includedPages = Number(el.sinp) || 0;
        const additionalPages = Math.max(0, pages - includedPages);
        return (el.price + (additionalPages * el.sPrice)) * quantity
    }

    if (!el.unit || el.unit == 'pc') return el.price * quantity

    // TODO: calc for other units and sprice
    return el.price

}

function calcPrice(el, quantity, config) {
 
    const out = {price:0};

    if (config?.pages && el.sPrice) {
        const pages = Number(config.pages) || 0;
        const includedPages = Number(el.sinp) || 0;
        const additionalPages = Math.max(0, pages - includedPages);

        out.additionalPages = additionalPages;
        out.pagePrice = el.sPrice;
        out.basePrice = el.price * quantity;
        out.amount = (el.price + (additionalPages * el.sPrice)) * quantity;
    } else {
        out.amount = el.price * quantity;
    }

    return out
}


function getCumulatedQuantity(product, quantity, config) {

    let qlcalc = 1;
    let cumulatedQuantity = 0;
    let media = false;
    let productSelector = false;

    if (config) {
        if (config.productSelector) productSelector = config.productSelector;
        if (config.media) media = config.media;
    }

    if (product.setup?.config?.qlcalc) qlcalc = product.setup.config.qlcalc;

    if (qlcalc == 1) {
        // um die Menge der gleichen Produkte mit gleicher Datei zu berechnen, muss der Mediencountainer mitgeliefert werden
        if (!media) return false

        // bei Mehrfachauswahl kann die Menge der gleichen Produkte mit gleicher Datei hier nicht berechnet werden
        // Der korrekte Staffelpreis wird dann ers nach Zusammenfassung aller Artikel ermittelt 
        if (media && media.length > 1) {
            return quantity/media.length
        }
   }

    if (!session.cart) getCart();
    if (!session.psm) getPSM();

    // Im Edit-Modus liegt die bearbeitete Warenkorbposition parallel im Selector vor.
    // Diese Position darf bei der Warenkorbkumulierung nicht doppelt berücksichtigt werden.
    const editCartIndex = session.psm?.value?.editCartIndex;
    const skipCartIndex = (productSelector == "psm" && Number.isInteger(editCartIndex) && editCartIndex >= 0)
        ? editCartIndex
        : null;

    // get quantity of equal products in cart  
    if (product?.pid && session.cart) {
        getCartItems().forEach((el, index) => {
            if (skipCartIndex !== null && index === skipCartIndex) return

            let extraCondition = true;

            // standard: cummulate on same product regardless of media files
            let numEqualProd = el.media.length;

            // cumulate only on equal media files
            if (qlcalc == 1) {
                if (media && media.length == 1) {
                    numEqualProd = el.media.filter(m => m.id === media[0].id).length;                                   
                }
            }

            // TODO: compare options
            let optionsDiff =  el.properties.optionsHash !== config.optionsHash;

            if (el.product?.pid == product.pid && extraCondition && !optionsDiff) cumulatedQuantity = cumulatedQuantity + el.properties.copies * numEqualProd;

        });

    }

    // include quantities from productSelectorModal (psm) if set in config
    // Preisberechnung sollte nur im Productselector mit {productSelector: "psm"} erfolgen,
    // da im Warenkorb auschließlich die  dort enthaltenen Positionen berücksichtigt werden sollen
    if (productSelector == "psm") {
        if (product?.pid && session.psm) {
            // get quantity of equal products in selector
            session.psm.value.psList.forEach((el) => {

                // el.ps kann kurzzeitig fehlen, während der Selector im ProductSelector neu aufgebaut wird
                if (!el?.ps?.status) return

                let extraCondition = true;

                // cumulate only on equal media files
                if (qlcalc == 1) {
                    if (media && el.ps.status.media && el.ps.status.media?.length == 1) {
                        extraCondition = (el.ps.status.media[0].id == media[0].id);
                    }
                }
                if (el.ps?.status?.product?.pid == product.pid && extraCondition && el.ps?.status?.productOptionsHash == config.optionsHash) {
                    let n = (el.ps.status.media?.length)? el.ps.status.media.length : 1;
                    cumulatedQuantity = cumulatedQuantity + parseInt(el.ps.status.properties.copies) * n;
                }
            });

        }
    }


    return cumulatedQuantity
}   

function getSelectedOptionPrices(psEl) {
    // Preise von ausgewählten (kostenpflichtigen) Optionen hinzufügen
    let selectedOptionPrices = [];
    if (psEl.ps.status.optionPrices) {
        for (let i in psEl.ps.status.optionPrices) {
            // wenn Option ausgewählt und nicht leer bzw. nicht leeres Array
            let oP = psEl.ps.status.optionPrices[i];
            // die Optionen werden im Formular unter dem Gruppennamen (groupName) gespeichert
            // wenn dort ein Wert existiert, wurde die Option ausgewählt und der Preis soll berücksichtigt werden

            // Check if is selected in form model
            // Form must contain an entry with the given groupName
            let is_selected = (psEl.ps.status.form[oP.groupName] == i 
            // ... or its an not empty array 
                    || Array.isArray(psEl.ps.status.form[oP.groupName]) && psEl.ps.status.form[oP.groupName].length > 0        
            );
            if (is_selected 
                    // It also must not be registered twice
                    && selectedOptionPrices.find((item) => item.pid === oP.pid) === undefined
            ) {
                selectedOptionPrices.push(oP);
            }
        }
    }
    return selectedOptionPrices
}

function getSelectedProductOptions(psEl,details=false) {

    let productOptions = [];
    if (psEl.ps.status.form) {
        for (let key in psEl.ps.status.form) {
            if (key.startsWith("po_")) {
                if (Array.isArray(psEl.ps.status.form[key])) {
                   productOptions = productOptions.concat(psEl.ps.status.form[key]);
                } else {
                   productOptions.push(psEl.ps.status.form[key]);
                }
            }
       }
    }

    if (details) {
        let detailedOptions = [];
        productOptions.forEach((po) => {
            let optDetail = psEl.ps.status.optionPrices[po];
            if (optDetail) {
                detailedOptions.push({
                    pid: optDetail.pid,
                    groupName: optDetail.groupName,
                    name: optDetail.name
                });
            }
        });
        return detailedOptions
    }

    return productOptions
}

function imgsource(img, resource, page) {

    const configStore = useConfigStore();
    const authStore = useAuthStore();

    if (!img || !img.resourceUrl) return "";
    // TODO Svg Anzeige immer norm? 
    //if (!resource || img.bintyp == "SVG") resource = "orig"

    let reference = "K";
    const sessionId = authStore.setup.sessionId;
    let queryString = "";

    if (!authStore.user && authStore.setup?.sessionId) {
        // user not logged in but sessionId is available, use sessionId as reference
        reference = authStore.setup.sessionId;
    } else {
        // user logged in, use userId as reference but append sessionId for session image access
        // user usually has only user or session images, but not both
        // this is only relevant for uploaded images from other device and if user is logged in on only one device.
        queryString = sessionId ? "?sessionId=" + sessionId : "";
    }

    let src = img.resourceUrl;
    if (page > 1) src = dirname(src) + "." + page + "/" +basename(src);

    return configStore.apiUrl + src.replace('{resource}', resource).replace('{ref}', reference) + queryString
}

function mediasource(img,resource) { return imgsource(img,resource); }

function fitin(sourceSize, targetSize) {

    const fittedSize = [];

    let sSize = [];

    if (Array.isArray(sourceSize)) sSize = sourceSize;
    else {
        if (sourceSize["width"] && sourceSize["height"]) sSize = [sourceSize["width"], sourceSize["height"]];
        else return []
    }

    if (!sSize[0] || !sSize[1] || !targetSize[0] || !targetSize[1]) return fittedSize

    if (sSize[0] / sSize[1] > targetSize[0] / targetSize[1]) {
        fittedSize[0] = targetSize[0];
        fittedSize[1] = sSize[1] / sSize[0] * fittedSize[0];
    } else {
        fittedSize[1] = targetSize[1];
        fittedSize[0] = sSize[0] / sSize[1] * fittedSize[1];
    }

    return fittedSize
}

function checkPrinttype(mediaObject, printtype) {

    let result = { satisfied: true, info: [] };

    // Dreifarb-Siebdruck
    if (printtype == "screen3") {
        // TODO: für alle medienobjekte prüfen
        if (mediaObject[0].bintyp != "SVG") return { satisfied: false, info: ["novector"] }
    }

    return result
}

function svgToDataUrl(svgstr) {

    return 'data:image/svg+xml;base64,' + btoa(svgstr)

}

/****   Bild von URL (mit credentials) holen und in base64 dataUrl umwandeln  ****/

async function getBase64FromUrl(url) {
    const data = await fetch(url, {
        credentials: 'include',
        cache: 'no-store'
    });
    const blob = await data.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
        };
    });
}

function color2hex(col) {
    let hexcol = "#" + dec2hex(col[0], 2) + dec2hex(col[1], 2) + dec2hex(col[2], 2);
    if (col[3]) hexcol += dec2hex(col[3], 2);
    return hexcol
}

function dec2hex(i, digits) {
    return (i + 0x10000).toString(16).substr(-digits)
}

async function fetchTemplate(path, out) {
    const configStore = useConfigStore();
    let url = configStore.templateUrl + "/" + path + "?m=6";  // TODO Cachebreaker

    let data = "";
    if (out == "object") {
        data = await fetch(url).then(data => { return data.json() });
    } else if (out == "vicobject") {
        let vic = await fetch(url).then(data => { return data.json() });
        data = { obj: { vic: vic }, type: "vic" };
    }

    return data
}

function acceptArray(data) {

    if (Array.isArray(data)) return data

    return [data]
}


function dirname(path) {
    return path.replace(/\/[^\/]*$/, '');
}

function basename(path) {
   return path.replace(/.*\//, '');
}

function psModal(data) {

    const prodselStore = useProdselStore();

    if (typeof data.showModal == "undefined") data.showModal = true;
    if (typeof data.psList == "undefined") data.psList = [{ active: true }];
    if (typeof data.psId == "undefined") data.psId = "ps1";
    prodselStore.psm = data;

}

// Standard Debounce. Verhinderung von zu häufigem Ausführen
const debounce = function(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
};

// Lazy: Funktion wird ausgeführt, wenn der Wert benötigt wird
const lazy = function (creator) {
    let res;
    let processed = false;
    return function () {
        if (processed) return res;
        res = creator.apply(this, arguments);
        processed = true;
        return res;
    };
};

const getFlagEmoji = function(countryCode) {
    // Validate the input to be exactly two characters long and all alphabetic
    if (!countryCode || countryCode.length !== 2 || !/^[a-zA-Z]+$/.test(countryCode)) {
      return '🏳️'; // White Flag Emoji for unknown or invalid country codes
    }
  
    // Convert the country code to uppercase to match the regional indicator symbols
    const code = countryCode.toUpperCase();
    
    // Calculate the offset for the regional indicator symbols
    const offset = 127397;
    
    // Convert each letter in the country code to its corresponding regional indicator symbol
    const flag = Array.from(code).map(letter => String.fromCodePoint(letter.charCodeAt(0) + offset)).join('');
    
    return flag;
  };

function pageLoaderIcon(options = {}) {
  let {
    width = 200,
    height = 300,
    radius = 25,
    strokeColor = window.getComputedStyle(document.body).getPropertyValue('--color-primary') || "#1e90ff",
    strokeWidth = 6,
    dashArray = "80 140",
    animationDuration = "1s",
    gradientFrom = "#f7f7f7",
    gradientTo = "#e5e5e5",
    gradientType = "linear",   // "linear" | "radial"

    // Optionen für Fehleranzeige
    // errorImageDataUri muss einne gültige Data-URI sein. http urls werden nicht aufgelöst
    useErrorImage = false,
    errorImageDataUri = window.getComputedStyle(document.body).getPropertyValue('--broken-image-uri').replace(/url\("(.+)"\)/g, '$1') , // Pfad zum fehlerhaften Bild-Symbol
    errorText = "Voransicht nicht möglich",
    errorTextColor = "#333",
    errorTextSize = 14,
    errorImageWidth = 80,
    errorImageHeight = 80,
  } = options;


  const gradient = gradientType === "radial"
    ? `
      <radialGradient id="bgGradient" cx="50%" cy="50%" r="75%">
        <stop offset="0%" stop-color="${gradientFrom}"/>
        <stop offset="100%" stop-color="${gradientTo}"/>
      </radialGradient>
    `
    : `
      <linearGradient id="bgGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stop-color="${gradientFrom}"/>
        <stop offset="100%" stop-color="${gradientTo}"/>
      </linearGradient>
    `;

  // Loader (Standard)
  const loaderSVG = `
    <g class="center">
      <g class="spin">
        <circle r="${radius}"
                fill="none"
                stroke="${strokeColor}"
                stroke-width="${strokeWidth}"
                stroke-linecap="round"
                stroke-dasharray="${dashArray}"/>
      </g>
    </g>
  `;

  // Fehleranzeige (statt Loader)
  const errorSVG = `
    <g class="center" transform="translate(50%, 40%)">
      <image
        href="${errorImageDataUri}"
        width="${errorImageWidth}"
        height="${errorImageHeight}"
        x="-${errorImageWidth / 2}"
        y="-${errorImageHeight / 2}"
      />
    </g>

    <text
      x="50%"
      y="80%"
      text-anchor="middle"
      fill="${errorTextColor}"
      font-size="${errorTextSize}"
      font-family="sans-serif"
    >${errorText}</text>
  `;

  const svg = `
<svg xmlns="http://www.w3.org/2000/svg"
     width="${width}" height="${height}"
     viewBox="0 0 ${width} ${height}"
     role="img" aria-label="Lade-Icon">

  <defs>
    ${gradient}
  </defs>

  <style>
    .center {
      transform-box: view-box;
      transform-origin: center;
      transform: translate(50%, 50%);
    }

    .spin {
      transform-box: fill-box;
      transform-origin: center;
      animation: spin ${animationDuration} linear infinite;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    svg { display: block; }
  </style>

  <rect width="100%" height="100%" fill="url(#bgGradient)"/>

  ${useErrorImage ? errorSVG : loaderSVG}

</svg>
  `.trim();

  // In Data-URI umwandeln
  const encoded = encodeURIComponent(svg)
    .replace(/'/g, "%27")
    .replace(/"/g, "%22");

  return `data:image/svg+xml,${encoded}`;
}

function xhrGet(url, withCredentials = true) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.withCredentials = withCredentials;

    xhr.onload = function() {
        resolve(xhr);
    };

    xhr.onerror = function() {
      reject(new Error("Network error"));
    };

    xhr.send();
    console.log("xhrGet: sending request to", url, "withCredentials:", withCredentials);
  });
}

function toLookupKey(value) {
    if (typeof value === 'number') return String(value)
    if (typeof value !== 'string') return ''

    const key = value.trim();
    if (!key) return ''

    return key
}

function idFromReferencePath(value) {
    const key = toLookupKey(value);
    if (!key) return ''

    const normalized = key.endsWith('/') ? key.slice(0, -1) : key;
    if (!normalized.includes('/')) return normalized

    const parts = normalized.split('/').filter(Boolean);
    if (!parts.length) return ''

    return parts[parts.length - 1]
}

function createOrderMediaPreview(orderMediaManager) {
    const orderMediaLoaded = ref(false);
    const orderMediaLoadingPromise = ref(null);
    const orderMediaLookup = ref({ byJid: {}, byBid: {}, byId: {} });

    function rebuildOrderMediaLookup() {
        const byJid = {};
        const byBid = {};
        const byId = {};

        const addEntry = (entry) => {
            if (!entry || typeof entry !== 'object') return

            const jidKey = toLookupKey(entry.jid);
            if (jidKey) byJid[jidKey] = entry;

            const bidKey = toLookupKey(entry.bid);
            if (bidKey) byBid[bidKey] = entry;

            const idKey = toLookupKey(entry.id);
            if (idKey) byId[idKey] = entry;
        };

        const images = Array.isArray(orderMediaManager.images.value) ? orderMediaManager.images.value : [];
        const media = Array.isArray(orderMediaManager.media.value) ? orderMediaManager.media.value : [];

        images.forEach(addEntry);
        media.forEach(addEntry);

        orderMediaLookup.value = { byJid, byBid, byId };
    }

    async function ensureOrderMediaLoaded() {
        if (orderMediaLoaded.value) return
        if (orderMediaLoadingPromise.value) {
            await orderMediaLoadingPromise.value;
            return
        }

        orderMediaLoadingPromise.value = (async () => {
            await Promise.all([
                orderMediaManager.loadImages(),
                orderMediaManager.loadMedia()
            ]);
            rebuildOrderMediaLookup();
            orderMediaLoaded.value = true;
        })();

        try {
            await orderMediaLoadingPromise.value;
        } finally {
            orderMediaLoadingPromise.value = null;
        }
    }

    function findMediaByCandidates(candidates, lookupKey) {
        for (const candidate of candidates) {
            const key = toLookupKey(candidate);
            if (!key) continue

            const mediaEntry = orderMediaLookup.value[lookupKey][key];
            if (mediaEntry) return mediaEntry
        }

        return null
    }

    function resolveItemImageReference(reference) {
        if (!reference) return null

        if (typeof reference === 'object' && reference.resourceUrl) {
            return reference
        }

        if (typeof reference === 'string' || typeof reference === 'number') {
            const key = toLookupKey(reference);
            return (
                orderMediaLookup.value.byJid[key]
                || orderMediaLookup.value.byBid[key]
                || orderMediaLookup.value.byId[key]
                || orderMediaLookup.value.byId[idFromReferencePath(key)]
                || null
            )
        }

        if (typeof reference !== 'object') return null

        const directJidMatch = findMediaByCandidates(
            [reference.jid, reference.JID, reference.mediaJid, reference.imageJid],
            'byJid'
        );
        if (directJidMatch) return directJidMatch

        const directBidMatch = findMediaByCandidates(
            [reference.bid, reference.BID, reference.mediaBid, reference.imageBid],
            'byBid'
        );
        if (directBidMatch) return directBidMatch

        const directIdMatch = findMediaByCandidates(
            [
                reference.id,
                reference.mediaId,
                reference.imageId,
                idFromReferencePath(reference['@id']),
                idFromReferencePath(reference.iri)
            ],
            'byId'
        );
        if (directIdMatch) return directIdMatch

        if (reference.image && typeof reference.image === 'object') {
            return resolveItemImageReference(reference.image)
        }

        if (reference.media && typeof reference.media === 'object') {
            return resolveItemImageReference(reference.media)
        }

        return null
    }

    function resolveItemImages(itemImages) {
        if (!Array.isArray(itemImages)) return []

        const resolved = [];
        const seen = new Set();

        itemImages.forEach((reference, index) => {
            const mediaEntry = resolveItemImageReference(reference);
            if (!mediaEntry) return

            const uniqKey = toLookupKey(mediaEntry.id)
                || toLookupKey(mediaEntry.jid)
                || toLookupKey(mediaEntry.bid)
                || toLookupKey(mediaEntry.resourceUrl)
                || `idx-${index}`;

            if (seen.has(uniqKey)) return

            seen.add(uniqKey);
            resolved.push(mediaEntry);
        });

        return resolved
    }

    function resetOrderMediaPreview() {
        orderMediaLoaded.value = false;
        orderMediaLoadingPromise.value = null;
        orderMediaLookup.value = { byJid: {}, byBid: {}, byId: {} };
    }

    return {
        orderMediaLoaded,
        orderMediaLookup,
        rebuildOrderMediaLookup,
        ensureOrderMediaLoaded,
        resolveItemImageReference,
        resolveItemImages,
        resetOrderMediaPreview
    }
}

function createOrderPurchasePreview({
    ppapiClient,
    ensureOrderMediaLoaded,
    rebuildOrderMediaLookup,
    resolveItemImages
}) {
    const ordersById = ref({});

    function getPurchaseItems(purchase) {
        if (Array.isArray(purchase?.items)) return purchase.items
        if (Array.isArray(purchase?.orderItems)) return purchase.orderItems
        if (Array.isArray(purchase?.purchaseItems)) return purchase.purchaseItems
        return []
    }

    function getOrderIdFromPurchase(purchase) {
        const kid = toLookupKey(purchase?.kid);
        const reference = toLookupKey(purchase?.reference ?? purchase?.aid);
        if (!kid || !reference) return ''
        return `${kid}-${reference}`
    }

    function findMatchingPurchase(orderData, purchase) {
        const purchases = Array.isArray(orderData?.purchases) ? orderData.purchases : [];
        const purchaseId = toLookupKey(purchase?.id);
        const aid = toLookupKey(purchase?.aid);

        return purchases.find((entry) => toLookupKey(entry?.id) === purchaseId)
            || purchases.find((entry) => toLookupKey(entry?.aid) === aid)
            || null
    }

    async function ensurePurchaseWithItemsLoaded(purchase) {
        if (getPurchaseItems(purchase).length > 0) return purchase

        const orderId = getOrderIdFromPurchase(purchase);
        if (!orderId) return purchase

        if (!ordersById.value[orderId]) {
            const response = await ppapiClient.get(`orders/${orderId}`, null, null, [{ includeItems: 1 }]);
            ordersById.value = {
                ...ordersById.value,
                [orderId]: typeof response?.data === 'function' ? response.data() : response
            };
        }

        return findMatchingPurchase(ordersById.value[orderId], purchase) || purchase
    }

    function collectPurchaseImages(purchase) {
        const itemImages = getPurchaseItems(purchase).flatMap((item) => Array.isArray(item?.itemImages) ? item.itemImages : []);
        return resolveItemImages(itemImages)
    }

    async function resolvePurchasePreviewImages(purchase) {
        const purchaseWithItems = await ensurePurchaseWithItemsLoaded(purchase);
        await ensureOrderMediaLoaded();
        rebuildOrderMediaLookup();
        return collectPurchaseImages(purchaseWithItems)
    }

    function resetOrderPurchasePreview() {
        ordersById.value = {};
    }

    return {
        resolvePurchasePreviewImages,
        resetOrderPurchasePreview
    }
}

function detectMobileContext() {
    if (typeof window === 'undefined') return false

    const userAgent = window.navigator?.userAgent ?? '';
    const hasMobileUa = /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
    const isIpadOsDesktopUa = window.navigator?.platform === 'MacIntel'
        && (window.navigator?.maxTouchPoints ?? 0) > 1;
    const hasTouchPoints = (window.navigator?.maxTouchPoints ?? 0) > 0;
    const hasCoarsePointer = window.matchMedia?.('(pointer: coarse)')?.matches ?? false;
    const isSmallViewport = window.matchMedia?.('(max-width: 960px)')?.matches ?? false;

    return hasMobileUa || isIpadOsDesktopUa || hasTouchPoints || hasCoarsePointer || isSmallViewport
}

const pdfChecks = [
    {
        key: 'note',
        getValue: (info) => info.pageinfo?.note ?? info.note,
        getErrors: (value) => {
            const notes = Array.isArray(value) ? value : [value];
            if (notes.length === 1 && notes[0] === 'No problems detected') return [];

            return notes
                .filter((note) => note && note !== 'No problems detected')
                .map((note) => ({ key: 'note', value: note }));
        }
    },
    {
        key: 'missingFonts',
        getValue: (info) => info.pageinfo?.missingFonts ?? info.missingFonts,
        getErrors: (value) => value === false ? [] : [{ key: 'missingFonts', value }]
    }
];

function getPdfInfo(media) {
    const pdfComponent = media?.components?.find((component) => component.type === 'pdf');
    if (!pdfComponent?.info) return null;

    if (typeof pdfComponent.info === 'object') return pdfComponent.info;

    try {
        return JSON.parse(pdfComponent.info);
    } catch {
        return null;
    }
}

function getMediaDocumentErrors(media) {
    const info = getPdfInfo(media);
    if (!info) return [];

    return pdfChecks.flatMap((check) => {
        const value = check.getValue(info);
        return value === undefined ? [] : check.getErrors(value);
    });
}

export { getSelectedProductOptions as a, getBase64FromUrl as b, checkPrinttype as c, color2hex as d, dec2hex as e, fitin as f, getSelectedOptionPrices as g, fetchTemplate as h, imgsource as i, acceptArray as j, debounce as k, lazy as l, mediasource as m, getFlagEmoji as n, pageLoaderIcon as o, psModal as p, quantityPrice as q, createOrderMediaPreview as r, svgToDataUrl as s, createOrderPurchasePreview as t, detectMobileContext as u, getMediaDocumentErrors as v, xhrGet as x };
